import React from 'react'
import './VideoStyles.css'
import video from '../assets/video.mp4'
import logo from '../assets/logo.png'
import { Link } from 'react-router-dom'


function Video() {
  return (
    <div className='hero'>
        <video autoPlay loop muted id='video'>
            <source src={video}></source>
        </video>
        
        <div className='content'>
          <img src={logo}/>
            
            <div className='links'>
                <Link to='/songs' className='btn'>Songs</Link>
                <Link to='/contact' className='btn'>Booking</Link>
            </div>
            
        </div>
    </div>

  )
}

export default Video